export var ImportRole;
(function (ImportRole) {
    ImportRole["AD_SDK"] = "ImportRole.AD_SDK";
    ImportRole["EXECUTABLE"] = "ImportRole.EXECUTABLE";
    ImportRole["LOW_LEVEL_PLAYER"] = "ImportRole.LOW_LEVEL_PLAYER";
    ImportRole["PLAYER"] = "ImportRole.PLAYER";
    ImportRole["PLAYER_UI"] = "ImportRole.PLAYER_UI";
    ImportRole["SMART_TAG_SKIN"] = "ImportRole.SMART_TAG_SKIN";
})(ImportRole || (ImportRole = {}));
